import React, { Component } from 'react';
import { object } from 'prop-types';
import { manualAPIs } from '../api';
import { Breakpoints, BrandHelper } from '../utils';
import { AuthRoles } from '../auth';

const withManuals = WrappedComponent => {
  class ManualComponent extends Component {
    state = {
      brand: null,
      productfamily: null,
      manualtype: null,
      language: null
    };

    async componentDidMount() {
      const { authUser } = this.props;
      let brand, manualtype, language;

      const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');

      const authBrands = BrandHelper.filterAuthorizedBrands(
        authUser && authUser.brands ? authUser.brands : [],
        isAGIUser
      );
      try {
        const filteredBrands = await manualAPIs.brands();
        // const filteredBrands = BrandHelper.filterAllBrandByAuthBrands(
        //   allBrands,
        //   authBrands
        // );

        brand = this.sortByName(filteredBrands);
        manualtype = this.sortByName(await manualAPIs.manualtypes());
        language = this.sortByName(await manualAPIs.languages());
      } catch (error) {
        // because brand is the only mandatory field, look after this very well
        if (!brand) {
          brand = { error: error.toString() };
        }
      }
      this.setState({
        brand,
        manualtype,
        language
      });
      window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    sortByName = arr =>
      arr && arr.length > 1
        ? arr.sort((a, b) => (a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0))
        : arr;

    handleResize = () => {
      this.setState({
        isMobile: window.innerWidth < Breakpoints.computerBreakpoint
      });
    };

    onChangeBrand = async Brand => {
      let productfamily;
      try {
        productfamily = this.sortByName(
          await manualAPIs.productfamilies({ Brand })
        );
        this.setState({ productfamily });
      } catch (error) {
        // TODO: do something
      }
    };

    onHandleSearch = async values => {
      try {
        return await manualAPIs.search(values);
      } catch (error) {
        return { error: error.toString() };
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onHandleSearch={this.onHandleSearch}
          onChangeBrand={this.onChangeBrand}
        />
      );
    }
  }
  ManualComponent.propTypes = {
    authUser: object.isRequired
  };
  return ManualComponent;
};

export default withManuals;
